module.exports = __webpack_public_path__ + "static/media/programming-laptop.d6d22bbf.png";